import { Action, configureStore, Dispatch, Middleware } from '@reduxjs/toolkit'
import { createReduxHistoryContext } from 'redux-first-history'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import { rootReducer } from '../rootReducer'
import IApplicationState from '../types/state'
import history from './history'
import { rootApi } from './root-api'

const { routerMiddleware, createReduxHistory } = createReduxHistoryContext({ history })

type ExtraArg = undefined
export type ThunkResult<R> = ThunkAction<R, IApplicationState, ExtraArg, Action>
export type MyThunkDispatch = ThunkDispatch<IApplicationState, ExtraArg, Action>

export const setupStore = (preloadedState?: Partial<IApplicationState>) => {
  return configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat([
        routerMiddleware as Middleware<{}, any, Dispatch>,
        rootApi.middleware as Middleware<{}, any, Dispatch>,
      ]),
  })
}

const store = setupStore()

export default setupStore()

export const historyRedux = createReduxHistory(store)
